// Lib
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

// Components
import Button from '../index';

// Styles
import { useStyles } from './RemoveFilterStyles';

const RemoveFilter = ({ title, onClick }) => {
  const { classes } = useStyles();

  return (
    <Button onClick={onClick} className={classes.button} variant="text">
      {title}
      <CloseIcon className={classes.closeIcon} />
    </Button>
  );
};

export default RemoveFilter;
